import { API_CALC_URL } from '../../urls';

export const API_CALC_GET_FACTORS = `${API_CALC_URL}/calculator/questions/factors`;
export const API_CALC_GET_QUESTIONS = `${API_CALC_URL}/calculator/questions/get`;
export const API_CALC_GET_CONFIG = `${API_CALC_URL}/calculator/config`;
